import { gql } from '@apollo/client';

export const SEND_SINGLE_SQUARE_TRANSACTION = gql`
mutation sendSingleSquareTransaction($token : String!,$paymentdata:CustomerPayment!) {
  sendSingleSquareTransaction(token: $token, paymentdata:$paymentdata) {
    status
    data
    error
  }
}
`;

export const SEND_VERIFICATION_TRANSACTIONS = gql`
mutation sendVerificationTransactions($phone : String!) {
  sendVerificationTransactions(phone: $phone) {
    status
    data
    error
  }
}
`;

export const CONIFRM_VERIFICATION_TRANSACTIONS = gql`
mutation verifyTempTransactions($phone : String!, $amount1 : Float!) {
  verifyTempTransactions(phone: $phone, amount1: $amount1) {
    status
    data
    error
  }
}
`;